<template>
    <div class="tab_wrapper font-responsive">
        <div class="tab_contents mobile:flex-column">
            <div class="tab_visual w-1/2 mobile:w-full">
                <div class="tab_photo-big">
                    <mid class="tab_photo-big--inner" v-if="tab.visual.slides" :component_data="{component:'slides', options:tab.visual.slides_options, images:tab.visual.slides, static_bg:tab.visual.img.src}"></mid>
                    <img class="tab_photo-big--inner" v-else :src="tab.visual.img.src" :alt="tab.visual.img.alt">
                </div>
                <video-block class="tab_video tab_video_l" v-if="tab.visual.video" :component_data="tab.visual.video"> </video-block>

                <span class="tab_photo-big--sidenote" v-if="tab.visual.img.sidenote" v-html="tab.visual.img.sidenote"></span>
            </div>
            <article class="tab_caption w-2/5 mobile:w-full">
                <header>
                    <figure class="tab_icon" :class="{customSize: isCustomSize(tab)}" v-html="tab.icon" :style="customColor(tab)+ customHeight(tab) + customWidth(tab) + customMarginTop(tab)"></figure>
                    <h2 v-html="tab.title"></h2>
                </header>
                <div class="tab_texts">
                    <p v-for="(text, index) in texts(tab)" v-html="text" :key="index"></p>
                </div>
            </article>

        </div>
    </div>
</template>

<script>
import video from '@/components/videoBlock/video'
export default {
    props: ['component_data'],
    methods: {
      customColor(tab){
        if(tab.icon_color) {
          return "color: "+tab.icon_color+";"
        }
      },
          customHeight(tab) {
        if (tab.icon_height) {
          return "height: " + tab.icon_height + ";";
        }
      },
      customWidth(tab) {
        if (tab.icon_width) {
          return "width: " + tab.icon_width + ";";
        }
      },
      customMarginTop(tab) {
        if (tab.icon_margin_top) {
          return "margin-top: " + tab.icon_margin_top + ";";
        }
      },
      isCustomSize(tab){
          return tab.icon_height || tab.icon_width || tab.icon_margin_top
      }
    },
    data(){
        return {
            tab: {
                "title": "",
                "id": "",
                "icon": "",
                "text": "",
                "visual": {
                    "img": {
                        "src": "",
                        "alt": ""
                    },
                    "video": {
                        "src": "",
                        "alt": "",
                        "url": ""
                    }
                },
                "component": ""
            }
        }
    },
    mounted(){
        this.$nextTick(()=>{
            Object.assign(this.tab, this.component_data)
        })
    },
    components: {
        "video-block": video
    }
}
</script>

<style scoped>
    .tab_photo-big--inner {
        overflow:hidden;
        border-top-left-radius: 6em;
    }
    .tab_video {
        content: '';
        position: absolute;
        height: 15.49vw;
        width: 25vw;        
        bottom: -6em;
        right: 0;
        z-index: 1;       
    }
    .tab_video {
        border-top-right-radius: 3em; 
    }
    .tab_video::before {
        content: '';
        position: absolute;
        height: 15.49vw;
        width: 25vw;
        z-index: -1;  
        right: 3em;
        bottom: 3em;
        border-top-left-radius: 3em;
        background: linear-gradient(to right, #AE0B11, #E41429);
    }
    @media (min-width: 1920px){
        .tab_photo-big {
            width: 620px;
            height: 680px;
        }
        .tab_video,
        .tab_video::before {
            width: 460px;
            height: 285px;            
        }
    }
    .tab_wrapper::before { 
        border-top-right-radius: 6em;
        left: 0;
    }
    @media(max-width:992px){
        .tab_photo-big {
            margin: 0;
        }
    }
</style>
<style>
    .tab_video_l .avc_thumb {
        border-top-right-radius: 3em; 
        overflow: hidden;
        
    }
</style>